import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: 16,
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_700.main
          : theme.palette.white_100.main
    }
  },

  dialogTitle: {
    // backgroundColor: '#fafafa',
    // borderBottom: '1px solid #e0e0e0',

    '& .MuiTypography-h6': {
      color: theme.palette.blue_300.main
    }
  },
  titleBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },

  dialogContent: {
    padding: theme.spacing(3),
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.white_100.main
  },

  dialogActions: {
    // padding: theme.spacing(2, 3, 3, 3),
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.white_100.main,
    gap: theme.spacing(1)
  },

  warningBox: {
    backgroundColor: theme.palette.yellow_200.main,
    border: '1px solid' + theme.palette.yellow_300.main,
    borderRadius: 8,
    padding: 16,
    marginBottom: theme.spacing(3)
  },

  warningText: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    color: theme.palette.yellow_500.main,
    fontWeight: 500
  },

  ticketInfo: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.gray_50.main,
    border:
      '1px solid' +
      (theme.palette.type === 'dark'
        ? theme.palette.dark_stroke.main
        : theme.palette.gray_stroke.main),
    borderRadius: 8,
    padding: 16,
    marginBottom: 16
  },

  ticketHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2)
  },

  contactName: {
    fontWeight: 600,
    color: theme.palette.blue_300.main
  },

  ticketDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },

  detailItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },

  instructionText: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    fontStyle: 'italic',
    textAlign: 'center',
    marginTop: theme.spacing(1)
  }
}))